import type {Writable} from 'type-fest'

import type {SupportedLocales} from '@/lib/locale/locale'
import queries from '@/queries/queries'
import type {ProductId} from '@/routes/product/$productId'
import {getProductDetails} from '@/services/productService'

export function createProductQueryKey(locale: SupportedLocales, productId: ProductId) {
  return [productId.retailer, productId.id, locale] as const
}

export default function createProductQueryOptions(
  locale: SupportedLocales,
  productId: ProductId,
  options?: {
    enabled?: boolean
    minimal?: boolean
    preload?: boolean
  },
) {
  const {enabled = true, minimal = false, preload = false} = options ?? {}
  const key = createProductQueryKey(locale, productId)
  return queries.getQueryOptions({
    name: 'productDetails',
    params: key as Writable<typeof key>,
    queryFn: async ({queryKey}) =>
      getProductDetails({
        retailer: queryKey[1],
        id: queryKey[2],
        locale: queryKey[3],
        // signal,
        minimal,
        preload,
      }),
    placeholderData: previousData => previousData,
    enabled,
  })
}
